module.exports = __webpack_public_path__ + "images/2-h73107997bffaef629d9105ba2739a52c.svg";